// TTL d'empreinte 1point6 = 7 jours, on garde une marge.
export const DELAI_MAX_LIVRAISON_CB_JOURS = 6;
